import React from 'react';
import { motion } from 'framer-motion';
import { useGclid } from '../hooks/useGclid';
import { buildShopUrl, trackCTAClick } from '../utils/tracking';
interface CtaButtonProps {
  label: string;
  position: string;
  className?: string;
}
export function CtaButton({
  label,
  position,
  className = ''
}: CtaButtonProps) {
  const SHOP_URL = 'https://hunderunde.shop/products/futtertopping-magen-darm';
  const gclid = useGclid();
  const href = buildShopUrl(SHOP_URL, gclid);
  return <motion.a href={href} onClick={() => trackCTAClick(label, position)} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`block w-full md:w-auto md:inline-block text-center bg-forestGreen text-white font-serif font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg hover:bg-forestGreen/90 transition-colors ${className}`} data-id="element-13">
      {label}
    </motion.a>;
}